<template>
  <page-option :disable-add="!checkAccess('workspace.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-layers</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.layer.name') }}</div>
    </template>
    <template #below-toolbar>
      <FilterSearch
        v-model="params"
        @click:create="onCreateItem()"
        placeholder="Tìm kiếm theo tên hoặc hệ quy chiếu"
        can-show-in-search
      >
        <div class="d-flex flex-sm-row flex-column flex-warp">
          <div class="filter-item">
            <field-group
              v-model="params.workspace_id"
              background-color="#FFFFFF"
              dense
              :items="workspace.items"
              :label="$t('sidebar.workspace.name')"
              :loading="workspace.loading"
              no-label
              outlined
              typeInput="v-select"
              item-text="name"
              item-value="id"
              hideDetails
              clearable
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.type"
              background-color="#FFFFFF"
              dense
              :items="types"
              label="Loại"
              no-label
              outlined
              hideDetails
              typeInput="v-select"
              clearable
            >
            </field-group>
          </div>
        </div>
      </FilterSearch>
      <!-- <v-card
        class="d-flex align-md-center pa-2 flex-column flex-md-row my-2"
        outlined
        tile
      >
        <div>Chọn lớp ở dưới để thêm vào bản đồ</div>
        <v-spacer></v-spacer>
        <div class="d-flex">
          <base-button
            className="ml-1"
            @click="onPreview(form_map.layers)"
            outlined
            :disabled="form_map.layers.length < 1"
          >
            Xem trước
          </base-button>
        </div>
      </v-card> -->
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        v-model="form_map.layers"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
        use-selected
        multi-select
      >
        <template v-slot:[`item.created_at`]="{ item }">
          <span>
            {{ item.created_at | dateTime('short') }}
          </span>
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>
            {{ item.updated_at | dateTime('short') }}
          </span>
        </template>
        <template v-slot:[`item.home_public`]="{ item }">
          <v-switch
            v-model="item.home_public"
            @change="changeTrangThai(item.id)"
            :loading="loading_switch == item.id"
          ></v-switch>
        </template>

        <template #grid-item="{ item }">
          <layer-item :value="item" :workspace="item.workspace">
            <div class="d-flex pt-2">
              <div class="btn-group">
                <base-button
                  class="text-none"
                  small
                  text
                  @click="onPreview([item])"
                >
                  <v-icon small left>mdi-eye</v-icon>
                  <span>{{ $t('layer.action.preview') }}</span>
                </base-button>
                <base-button
                  text
                  class="text-none"
                  small
                  color="primary"
                  @click.stop="onUpdateItem(item)"
                >
                  <v-icon small left>mdi-cog</v-icon>
                  <span>{{ $t('workspace.setting') }}</span>
                </base-button>
                <base-button
                  type-action="delete"
                  class="text-none"
                  text
                  small
                  @click.stop="onDeleteItem(item)"
                  v-if="checkAccess('layer.delete', item)"
                >
                </base-button>
              </div>
            </div>
          </layer-item>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
    <LayerCreateDialog
      ref="createDialog"
      @reset="onReset"
      :workspace="workspace.items"
    />
    <LayerUpdateDialog ref="updateDialog" @reset="onReset" />
    <LayerInfoDialog ref="LayerInfoDialog" />
    <LayerFeatures ref="layerFeatures" :fields="fields" :layer_id="layer_id" />

    <LayerField :id="datastore_detail_id" ref="layerField" />
  </page-option>
</template>

<script>
import LayerItem from './all-layer-item.vue'
import FilterSearch from '@layouts/filter-search.vue'
import { API_LAYER, API_WORKSPACE } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import LayerUpdateDialog from '../layer-update-dialog.vue'
import LayerCreateDialog from '../layer-create-dialog.vue'
import LayerInfoDialog from '../layer-info-dialog.vue'
import { saveAs } from 'file-saver'
import LayerFeatures from './dialog/feature.vue'
import { sdk } from '@service/http/axios'
import LayerField from '../../datastores/datastore-detail-item/field.vue'

export default {
  mixins: [],
  components: {
    LayerItem,
    LayerUpdateDialog,
    FilterSearch,
    LayerCreateDialog,
    LayerInfoDialog,
    LayerFeatures,
    LayerField
  },
  props: {},
  data: (vm) => ({
    fields: [],
    layer_id: 0,
    datastore_detail_id: 0,
    form_map: {
      layers: [],
      map: null,
    },
    default_params: {
      workspace_id: vm.id,
      is_publish: true,
      with: 'workspace',
    },
    params: {
      search: '',
      inactive: null,
      type: '',
      workspace_id: '',
      with: 'workspace',
    },
    loading_switch: null,
    menus: [
      {
        icon: 'mdi-eye',
        title: vm.$t('layer.action.preview'),
        handler: (item) => vm.onPreview([item]),
        disabled: (item) => !vm.checkAccess('layer.update', item),
      },
      {
        icon: 'mdi-information-outline',
        title: vm.$t('layer.action.show_fields'),
        handler: (item) => vm.onShowFields(item),
      },
      {
        icon: 'mdi-information-outline',
        title: vm.$t('layer.action.show_features'),
        handler: (item) => vm.onShowFeatures(item),
      },
      {
        icon: 'mdi-microsoft-excel',
        title: vm.$t('layer.action.export'),
        handler: (item) => vm.onExportExcel(item),
      },
      // {
      //   icon: 'mdi-format-list-bulleted',
      //   title: 'Thông tin thuộc tính',
      //   handler: (item) => vm.onShowDialogInfo(item),
      //   disabled: (item) => !vm.checkAccess('layer.update', item),
      // },
      {
        type: 'setting',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('layer.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('layer.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Loại',
        align: 'start',
        sortable: false,
        value: 'type',
      },
      {
        trans: 'layer.projection',
        align: 'start',
        sortable: true,
        value: 'srs',
      },
      {
        trans: 'layer.belong_to_workspace',
        align: 'start',
        sortable: false,
        value: 'workspace.name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        align: 'center',
      },
    ],
    loading: false,
    resource_headers: [
      {
        trans: 'datastore.layer.name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'datastore.layer.action',
        align: 'start',
        sortable: false,
        value: 'action',
      },
    ],
    map_items: { items: [], loading: false },
    types: [
      'Point',
      'LineString',
      'Polygon',
      'MultiPoint',
      'MultiLineString',
      'MultiPolygon',
    ],
    workspace: {
      loading: false,
      items: [],
    },
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_LAYER
    },
    mapItemSelect() {
      return [
        ...this.map_items.items,
        { name: this.$i18n.t('layer.createMap'), nodata: true },
      ]
    },
  },
  mounted() {
    this.getWorkspaces()
    this.form_map.map = { name: this.$i18n.t('layer.createMap'), nodata: true }
  },
  methods: {
    async changeTrangThai(id) {
      this.loading_switch = id
      let res = await API_LAYER.publicLayer(id, { type: 'layer' })
      if (res.isDone) {
        this.loading_switch = null
      } else this.onReset()
    },
    async onExportExcel(layer) {
      const res = await this.api.export(layer.id)
      if (res && res.isDone) {
        saveAs(new Blob([res.data]), `${layer.name}.xlsx`)
      }
    },
    onResetPassword(item) {
      this.$refs.resetdialog.open(item)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onUpdateItem(item) {
      this.$refs.updateDialog.open(item, EDIT_TYPE.UPDATE)
    },
    onCreateItem() {
      this.$refs.createDialog.open(null, EDIT_TYPE.CREATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
    onCreateMap() {
      let isCreate = this.form_map.map.nodata
      this.$emit('click:add-map', {
        name: isCreate ? 'Bản đồ mới' : this.form_map.map.name,
        ...this.form_map.map,
        layers: this.form_map.layers,
        type: isCreate ? EDIT_TYPE.CREATE : EDIT_TYPE.UPDATE,
      })
    },
    onPreview(layers) {
      if (!layers || layers.length < 1) return
      this.$router.push({
        name: 'map',
        query: { layer_ids: layers.map((x) => x.id).join(',') },
      })
    },
    getWorkspaces() {
      this.workspace.loading = true
      API_WORKSPACE.list()
        .then((res) => {
          this.workspace.items = res.data
        })
        .finally(() => {
          this.workspace.loading = false
        })
    },
    onShowDialogInfo(item) {
      this.$refs.LayerInfoDialog.open(item)
    },
    onShowFields(item) {
      this.datastore_detail_id = item.datastore_detail_id
      this.$refs.layerField.open()
    },
    async onShowFeatures(item) {
      this.layer_id = item.id
      const res = await sdk.request({
        url: `layers/${this.layer_id}/fields`,
        method: 'get',
      })
      this.fields = res.data
      this.$refs.layerFeatures.open(item)
    },
  },
}
</script>
